import "../SignIn/SignIn.css";
import { Image, Container, Col, Row } from "react-bootstrap";
import Logo from "../../../assets/communityXlogo.svg";
import signupimg from "../../../assets/signup.png";
import ErrorLabel from "../../../ErrorLabel/ErrorLabel";

import "react-step-progress/dist/index.css";
// import GeneralInfo from "../GeneralInfo/GeneralInfo";
// import BusinessInfo from "../BusinessInfo/BusinessInfo";
// import Acknowledgement from "../Acknowledgement/Acknowledgement";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";

// const step1Content = <GeneralInfo/>;
// const step2Content = <BusinessInfo/>;
// const step3Content = <Acknowledgement/>;

function nextHandler() {
  return false;
}

function step2Validator() {
  // return false;
}

function step3Validator() {}

function onFormSubmit() {}

const SignUp = ({ Status }) => {
  return (
    <>
      <div className="main">
        <Container>
          <Row className="justify-content-md-center py-3">
            <Col xs lg="6" className="page-content-left">
              <Image src={signupimg} width="100%" className="mt-5 pt-5"></Image>
              <p className="login-text1 mt-4">Lorem ipsum dolor sit amet</p>
              <p className="login-text2 mt-2">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam
                eu turpis molestie, dictum est a, mattis tellus. Sed dignissim,
                metus nec fringilla accumsan,{" "}
              </p>
            </Col>
            <Col
              md="6"
              className="page-content-right page-content-right-fullwidth"
            >
              {/* {show ==true ? <Validate/> : null} */}
              <div className="text-center mb-2">
                <Image src={Logo} className="logo_Image"></Image>
                <p className="sign-second mt-4 pt-0">Sign Up</p>
              </div>
              {/* <Tabs
              defaultActiveKey="step1"
              id="uncontrolled-tab-example"
              className="mb-3 step-form"
            >
              <Tab eventKey="step1" title="GENERAL INFO">
                 <GeneralInfo/>
              </Tab>
              <Tab eventKey="step2" title="BUSINESS INFO">
                 <BusinessInfo/>
              </Tab>
              <Tab eventKey="step3" title="ACKNOWLEDGEMENT">
                 <Acknowledgement/>
              </Tab>
            </Tabs> */}
              {/* <StepProgressBar
                startingStep={0}
                onSubmit={onFormSubmit}
               
                steps={[
                  {
                    label: 'GENERAL INFO',
                    name: 'step 1',
                    content: step1Content,
                  },
                  {
                    label: 'BUSINESS INFO',
                    name: 'step 2',
                    content: step2Content,
                     validator: step2Validator
                  },
                  {
                    label: 'ACKNOWLEDGEMENT',
                    name: 'step 3',
                    content: step3Content,
                    // validator: step3Validator
                  }
                ]}
              /> */}
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default SignUp;
